import {Component, OnInit, ViewChild} from '@angular/core';
import { BackEndApiService } from '../../../service/back-end-api.service';
import { GlobalService } from '../../../../global/global.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-list-categories',
  templateUrl: './list-categories.component.html',
  styleUrls: ['./list-categories.component.css']
})
export class ListCategoriesComponent implements OnInit {

  categories;

  columns: string[] = [ 'name', 'action' ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private api: BackEndApiService,
    private global: GlobalService
  ) { }

  ngOnInit(): void {
    this.global.dialogPreloader();
    this.api.getCategories().subscribe(props => {
      this.categories = new MatTableDataSource(props);
      this.categories.data = props;
      this.categories.paginator = this.paginator;

      if (props.length > 0) {
        this.global.hideDialog();
      }

      if (props.length === 0) {
        this.global.dialogInfoEmptyList();
      }

    });
  }

  delete(id: number | string): void {
    this.api.deleteCategory(id).subscribe(props => {
      this.categories.data = this.categories.data.filter(item => item.id !== id);
      this.global.dialogDeleteItem();
    });
  }

}
